import { FetchState as SharedFetchState } from 'sn.ticketing.frontends.shared/default/mobx/fetch-state';
import type { FetchStateConfig } from 'sn.ticketing.frontends.shared/default/mobx/fetch-state';

import type { BaseResponse } from '@app/types/BaseResponse.ts';
import { HttpCancelledError } from '@/entities/httpClient/errors/HttpCancelledError.ts';
import { HttpTimeoutError } from '@/entities/httpClient/errors/HttpTimeoutError.ts';

const injected = {
  isCancelledError: (error: unknown) => error instanceof HttpCancelledError,
  isTimeoutError: (error: unknown) => error instanceof HttpTimeoutError,
};

const withInjectedConfig = (config?: FetchStateConfig): FetchStateConfig => ({ ...config, ...injected });

export { SharedFetchState };

export class SharedAPPFetchState<TData, TError = BaseResponse['error']> extends SharedFetchState<
  BaseResponse<TData, TError>,
  BaseResponse<TData, TError>['error'] & TError,
  TData
> {
  constructor(config?: FetchStateConfig) {
    super(withInjectedConfig(config));
  }
}

export class SharedPlainFetchState<TData> extends SharedFetchState<TData, never, TData> {
  constructor(config?: FetchStateConfig) {
    super(withInjectedConfig(config));
  }
}
